import { render, staticRenderFns } from "./EndorsementPage.vue?vue&type=template&id=06074694"
import script from "./EndorsementPage.vue?vue&type=script&lang=js"
export * from "./EndorsementPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports